import React from "react";
import {Card, Modal, Tag, Timeline, Typography} from "antd";
import {CheckCircleOutlined, ClockCircleOutlined} from "@ant-design/icons";
import {formatFrenchDate} from "../../../../variables/functions";

const OrderTimeline = ({actionsSurCommandes, title, open, cancel}) => {
    const {Text} = Typography;

    // Map action types to icons
    const getActionIcon = (action) => {
        switch (action) {
            case "INITIER":
                return <ClockCircleOutlined/>;
            case "VALIDER":
                return <CheckCircleOutlined style={{color: "green"}}/>;
            case "AUTORISER":
                return <CheckCircleOutlined style={{color: "green"}}/>;
            case "EDITER":
                return <ClockCircleOutlined style={{color: "blue"}}/>;
            case "TRAITER":
                return <CheckCircleOutlined style={{color: "blue"}}/>;
            default:
                return <ClockCircleOutlined/>;
        }
    };

    // Render actor details if available
    const renderActorDetails = (acteur) => {
        if (!acteur) return null;
        const {personne} = acteur;
        return (
            <div style={{padding: "0px", marginTop: 10}}>
                {personne && (
                    <Text strong>{`${personne.nom || ""} ${personne.prenom || ""}`}</Text>
                )}
                {acteur.profil && (
                    <Tag style={{marginLeft: 5}}>{acteur.profil.nom}</Tag>
                )}
                {personne && personne.email && (
                    <div>
                        <Text type="secondary">{personne.email}</Text>
                    </div>
                )}
            </div>
        );
    };

    // Create a timeline item for each action
    const renderTimelineItems = () =>
        actionsSurCommandes.map((actionItem, index) => {
            const {action, dateAction, commentaire, actionLabel, acteur} = actionItem;
            const icon = getActionIcon(action);
            return (
                <Timeline.Item
                    key={index}
                    dot={icon}
                    label={
                        <Tag color="blue">
                            <Text style={{color: "#000"}} type="secondary">
                                {formatFrenchDate(dateAction)}
                            </Text>
                        </Tag>
                    }
                >
                    <Text strong style={{color: "blue"}}>
                        {action}
                    </Text>
                    {actionLabel && (
                        <Text type="secondary" style={{marginLeft: 10}}>
                            {actionLabel}
                        </Text>
                    )}
                    <Card
                        bordered
                        style={{
                            padding: 0,
                            alignItems: "center",
                            background: "beige",
                            marginTop: 10,
                        }}
                    >
                        {commentaire && (
                            <Text italic style={{textAlign: "left"}}>
                                {commentaire}
                            </Text>
                        )}
                        {renderActorDetails(acteur)}
                    </Card>
                </Timeline.Item>
            );
        });

    return (
        <Modal
            open={open}
            onCancel={cancel}
            footer={null}
            width={750}
            title={<div style={{marginTop: "20px"}}>{title}</div>}
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div style={{marginRight: "90px"}}>
                <Timeline mode="left">{renderTimelineItems()}</Timeline>
            </div>
        </Modal>
    );
};

export default OrderTimeline;
